import { Goals, HouseholdSize, type Quiz } from '../defs/quiz';

export const SEGMENT_QUIZ_RESULTS_EVENT_NAME = 'quiz-results';

const goalsSegmentProperties = {
  [Goals.SaveTime]: 'save_time',
  [Goals.ImproveHealth]: 'improve_health',
  [Goals.LoseWeight]: 'lose_weight',
  [Goals.TryNewThings]: 'try_new_things',
  [Goals.GroceryShopLess]: 'grocery_shop_less',
  [Goals.WasteLessFood]: 'waste_less_food',
  [Goals.SaveMoney]: 'save_money',
  [Goals.SimplifyCooking]: 'simplify_cooking',
};

function getAdultSegmentValue(
  quiz: Pick<Quiz, 'householdSize' | 'adultsCount'>
) {
  const { householdSize, adultsCount } = quiz;

  if (adultsCount !== null) {
    return adultsCount;
  }

  if (
    householdSize === HouseholdSize.ME_PLUS_MORE ||
    householdSize === HouseholdSize.ME_PLUS_ONE
  ) {
    // We display "1" to the user in this scenario, so we want to log it
    return 1;
  }

  return adultsCount;
}

export function getGoalsSegmentData(goals: Goals[]) {
  return Object.keys(goalsSegmentProperties).reduce(
    (acc, key) => {
      const k = parseInt(key);
      const segmentKey =
        goalsSegmentProperties[k as keyof typeof goalsSegmentProperties];

      acc[segmentKey] = goals.includes(k);
      return acc;
    },
    {} as { [key: string]: boolean | undefined }
  );
}

export function getHouseholdSizeSegmentData(quiz: Quiz) {
  return {
    household_size: quiz.householdSize,
    num_adults: getAdultSegmentValue(quiz),
    num_older_children: quiz.childrenCount,
    num_younger_children: quiz.youngChildrenCount,

    // deprecated: but not removing so we don't break anything in Segment
    num_middle_children: 0,
  };
}
